import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const TickerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Ticker = styled.span`
  ${typographyV2.bodySm};
  font-family: var(--font-nort);
  text-transform: uppercase;
`;
